import { ACTION_NAMES } from "../utils/actionConstants";

const requestMaintenanceStatus = status => ({
    type: ACTION_NAMES.MAINTENANCE.REQUEST_MAINTENANCE_STATUS,
    payload: null
});

const receiveMaintenanceStatus = status => ({
    type: ACTION_NAMES.MAINTENANCE.RECEIVE_MAINTENANCE_STATUS,
    payload: status
});

export const actions = {
    checkMaintenaceStatus: () => (dispatch, getState) => {
        console.log("Checking maintenance status")
        dispatch(requestMaintenanceStatus())

        // Let's check the deployment status
        const myRequest = new Request(process.env.REACT_APP_MAINTENANCE_LOCATION)

        return new Promise((resolve, reject) => {
            fetch(myRequest, {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'content-type': 'application/json',
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                return response.json()
            })
            .then(json => {
                console.log("Got the json", json)
                if (json.status === "MAINT") {
                    dispatch(receiveMaintenanceStatus(json))
                    //history.push("/maintenance", json)
                    resolve(false)
                } else {
                    dispatch(receiveMaintenanceStatus({ status: "OK", message: "" }))
                    resolve(true)
                }
            })
            .catch((error) => {
                console.log("Error maintenance")
                dispatch(receiveMaintenanceStatus({ status: "OK", message: "" }))
                resolve(true)
            })
        })

    }
}
